import { toast } from "react-toastify";
import { HTTPURL } from "../../../constants/Matcher";


// subject add 
export async function subject_add(data) {
    try {
        const response = await fetch(HTTPURL + 'api/subject-add', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        });
        const responseData = await response.json();
        if (responseData.status) {
            toast.success(responseData?.message);
        } else {
            toast.error(responseData?.message);
        }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}

// get all subjects 
export async function subject_all(id) {
    try {
        const response = await fetch(HTTPURL + `api/teacher/teacher-subjectlist/?id=${id}`);
        const responseData = await response.json();
        // if (responseData.status) {
        //     toast.success(responseData?.message);
        // } else {
        //     toast.error(responseData?.message);
        // }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}

// subject edit 
export async function subject_edit(id) {
    try {
        const response = await fetch(HTTPURL + `api/subject-edit/?id=${id?.id}`);
        const responseData = await response.json();
        if (responseData.status) {
            // toast.success(responseData?.message);
        } else {
            toast.error(responseData?.message);
        }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}

// subject update 
export async function subject_update(id, data) {
    try {
        const response = await fetch(HTTPURL + `api/subject-update/?id=${id?.id}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        });
        const responseData = await response.json();
        if (responseData.status) {
            // toast.success(responseData?.message);
        } else {
            toast.error(responseData?.message);
        }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}

// subject delete
export async function subject_destroy(id) {
    try {
        const response = await fetch(HTTPURL + `api/subject-distroy?id=${id}`);
        const responseData = await response.json();
        if (responseData.status) {
            // toast.success(responseData?.message);
        } else {
            toast.error(responseData?.message);
        }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}


